<template>
  <div class="text-title font-bold mb-5">Booking Confirmed</div>
  <div class="content-text">
    <p>Thank you for booking your tickets with us!</p>
    <p>
      Your reservation for {{ event.title }} in {{ show.city }} on
      {{
        show.start
          ? dateTimeFormat(show.start.toDate(), "dddd D MMMM YYYY H:mm")
          : "-"
      }}
      is confirmed.
    </p>

    <p class="mt-5">Enjoy the show!</p>

    <div class="pt-10" v-if="!isGuest">
      <default-button
        class="w-full sm:w-2/6"
        label="Show My Tickets"
        @click="$router.push({ name: 'accountTicket' })"
      />
    </div>
  </div>
</template>
<script>
import { dateTimeFormat, seatNameShorter } from "@/utils/helper";
import { computed, reactive, toRefs } from "vue";
import { useStore } from "vuex";
import DefaultButton from "@/components/button/DefaultButton.vue";
import { useMeta } from "vue-meta";
export default {
  components: { DefaultButton },
  name: "PaymentSuccess",
  setup() {
    useMeta({
      title: "Payment Success",
    });
    const store = useStore();
    const state = reactive({
      event: computed(() => store.state.event.event),
      selectedSeats: computed(() => store.state.reservation.selectedSeats),
      reservation: computed(() => store.state.reservation.reservation),
      isGuest: computed(() => store.state.auth.isGuest),
      show: computed(() => store.state.show.show),
    });

    return {
      ...toRefs(state),
      dateTimeFormat,
      seatNameShorter,
    };
  },
};
</script>
